import { getAccessToken, setAccessToken, getRefreshToken, setRefreshToken, setIdToken, getSelectedPraticienFiness } from "./localStorage";
import { ApplicationType } from "@/types/common";
import { UpdatePasswordError } from "./UpdatePasswordError";
import { fetchRefreshAccessToken } from "@/api/auth/fetchAuth";

let count = 0;

type FetchProps = {
  url: string;
  options: RequestInit;
  application?: ApplicationType;
  tokenRescu?: string;
};

function appendFinessToUrl(url: string): string {
  const finess = getSelectedPraticienFiness();
  if (!finess) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}adeli=${encodeURIComponent(finess)}`;
}

export const fetchAPI = async ({ url, options, application, tokenRescu }: FetchProps) => {
  console.log("[fetchAPI] start fetch with url:", url);
  const token = getAccessToken() || tokenRescu;
  const baseURL = process.env.REACT_APP_API_URL_ACCOUNT;

  const urlWithFiness = appendFinessToUrl(url);

  const optionsWithToken = {
    headers: {
      ...(options.headers || {}),
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-App-Version": "web",
      ...(token ? { Authorization: `Bearer ${token.split('"')[1]}` } : {}),
    },
    ...options,
  }
  console.log("optionsWithToken =>", `Bearer ${token?.split('"')[1]}` );
  let response: Response;

  try {
    response = await fetch(`${baseURL}${urlWithFiness}`, optionsWithToken);

  } catch (fetchError) {
    // Erreur réseau ou CORS - probablement un 401 non géré côté serveur
    console.log("[fetchAPI] Erreur fetch (réseau/CORS):", count)
    
    // Tenter un refresh token
    if (count < 5) {
      console.log("before get refresh token");
      const refreshToken = await getRefreshToken();
      console.log("refreshToken", refreshToken);
      if (refreshToken) {
        try {
          const result = await fetchRefreshAccessToken({
            refreshToken: refreshToken?.split('"')[1],
          });
          console.log("result", result);
          const resultParsed = result
          setAccessToken(JSON.stringify(resultParsed.idToken));
          setIdToken(JSON.stringify(resultParsed.accessToken));
          count += 1;
          console.log("[fetchAPI] refetch after refresh");
          return fetchAPI({ url, options, tokenRescu: JSON.stringify(resultParsed.accessToken) });
        } catch (refreshError) {
          console.log("[fetchAPI] Erreur refresh:", refreshError);
        }
      }
    }
    
    // Si le refresh échoue ou pas de token, rediriger
    setAccessToken("");
    setIdToken("");
    window.location.replace("/welcome");
    throw new Error("session_expired");
  }

  console.log("[fetchAPI] response:", response);

  // Parser la réponse de manière sécurisée
  let parsedResponse: any = {};
  try {
    const text = await response.text();
    if (text) {
      parsedResponse = JSON.parse(text);
    }
  } catch (parseError) {
    console.log("[fetchAPI] Erreur parsing JSON:", parseError);
  }

  if (response.status === 400) {
    throw new Error(parsedResponse?.message || "server_error");
  }

  if (response.status === 401 && parsedResponse.errorCode === 13100) {
    console.log("in throw error");
    throw new UpdatePasswordError(parsedResponse?.code);
  }

  if (parsedResponse?.message === "Invalid token") {
    setAccessToken("");
    setIdToken("");
    window.location.replace("/welcome");
    throw new Error("session_expired");
  }

  if (response.status === 401 && (parsedResponse?.message === "The incoming token has expired" || parsedResponse?.message === "Unauthorized")) {
    if (count >= 3) {
      setAccessToken("");
      setIdToken("");
      window.location.replace("/welcome");
      throw new Error("session_expired");
    }

    const refreshToken = getRefreshToken();

    if (refreshToken) {
      try {
        const result = await fetchRefreshAccessToken({
          refreshToken: refreshToken?.split('"')[1],
        });
        const resultParsed = await result.json();

        console.log("refresh", resultParsed);
        setAccessToken(resultParsed.accessToken);
        setRefreshToken(resultParsed.refresh);
        count += 1;
        return fetchAPI({ url, options });
      } catch (e) {
        setAccessToken("");
        setIdToken("");
        window.location.replace("/welcome");
      }
    } else {
      setAccessToken("");
      setIdToken("");
      window.location.replace("/welcome");
    }
  }

  if (response.status > 206) {
    throw new Error(parsedResponse?.message);
  }

  return parsedResponse;
};
